var map = {
	"./empty.md": "I12p",
	"./page/en/privacypolicy.md": "YcA2",
	"./page/en/termsofservice.md": "npg3",
	"./page/pt/privacypolicy.md": "uxqk",
	"./page/pt/termsofservice.md": "5wUw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fuwu";


//////////////////
// WEBPACK FOOTER
// ./src/assets/md ^\.\/.*\.md$
// module id = fuwu
// module chunks = 1